class NewsletterPopup extends HTMLElement {
    constructor() {
        super();

        this.popup = this;
        this.timeToShow = parseInt(this.popup.getAttribute('data-delay'));

        const isHomePage =
            window.location.pathname === '/' ||
            document.body.classList.contains('template-index');

        // Show only once per browser session and only on homepage
        if (
            isHomePage &&
            !sessionStorage.getItem('newsletter-popup-shown')
        ) {
            sessionStorage.setItem('newsletter-popup-shown', 'true');

            setTimeout(() => {
                document.body.classList.add('newsletter-show');
            }, this.timeToShow);

            setTimeout(() => {
                document.body.classList.add('show-newsletter-image');
            }, this.timeToShow + 700);
        }

        document.body.addEventListener(
            'click',
            this.onBodyClickEvent.bind(this)
        );

        const closeBtn = this.querySelector('[data-close-newsletter-popup]');
        if (closeBtn) {
            closeBtn.addEventListener(
                'click',
                this.setClosePopup.bind(this)
            );
        }

        const form = this.querySelector('#ContactPopup');
        if (form) {
            form.addEventListener(
                'submit',
                this.setClosePopup.bind(this)
            );
        }
    }

    setClosePopup() {
        document.body.classList.remove('newsletter-show');

        setTimeout(() => {
            document.body.classList.remove('show-newsletter-image');
        }, 700);
    }

    onBodyClickEvent(event) {
        if (
            !this.contains(event.target) &&
            $(event.target).closest('[data-open-newsletter-popup]').length === 0 &&
            document.body.classList.contains('newsletter-show')
        ) {
            this.setClosePopup();
        }
    }
}

customElements.define('newsletter-popup', NewsletterPopup);

class NewsletterMessagePopup extends HTMLElement {
    constructor() {
        super();

        const closeBtn = this.querySelector(
            '[data-close-newsletter-message-popup]'
        );

        if (closeBtn) {
            closeBtn.addEventListener(
                'click',
                this.close.bind(this)
            );
        }

        document.body.addEventListener(
            'click',
            this.onBodyClickEvent.bind(this)
        );
    }

    close() {
        document.body.classList.remove('newsletter-message-show');
    }

    onBodyClickEvent(event) {
        if (!this.contains(event.target)) {
            this.close();
        }
    }
}

customElements.define('newsletter-message-popup', NewsletterMessagePopup);